import styled from './empresa.module.css';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import { CiEdit } from 'react-icons/ci';
import { BiCheck } from 'react-icons/bi';
import Modal from 'react-modal';
import ModalW from 'react-modal';
import ModalF from 'react-modal';
import ModalL from 'react-modal';
import ModalB from 'react-modal';
import { useContext, useEffect, useState } from 'react';
import ModalEmail from '../../components/ModalEmail';
import ModalWats from '../../components/ModalWats';
import ModalFatu from '../../components/ModalFatu';
import ModalLogo from '../../components/ModalLogo';
import ModalWhabol from '../../components/ModalWhabol';
import { AuthContext } from '../../services/global';
import api from '../../services/api';
import { Alerta } from '../../utils/functions';

import { BsWhatsapp } from 'react-icons/bs';


Modal.setAppElement('#root');
ModalW.setAppElement('#root');
ModalF.setAppElement('#root');
ModalL.setAppElement('#root');
ModalB.setAppElement('#root');

function Empresa() {
    const login = JSON.parse(localStorage.getItem("login"));
    const cgccli = login.cgccli;
    const nomcli = login.nomcli;
    const [endcli, setEndCli] = useState('');
    const [foncla, setFoncla] = useState('');
    const [endele, setEndele] = useState('');
    const [whatsa, setWhatsa] = useState('');
    const [whabol, setbol] = useState('');
    const [qtdfun, setQtd] = useState('');
    const [fatcli, setFat] = useState('');
    const [imgcli, setImgcli] = useState('');
    const [sencli, setSencli] = useState('');
    const { modalIsOpenE, setIsOpenE } = useContext(AuthContext);
    const { modalIsOpenW, setIsOpenW } = useContext(AuthContext);
    const { modalIsOpenF, setIsOpenF } = useContext(AuthContext);
    const { modalIsOpenL, setIsOpenL } = useContext(AuthContext);
    const { modalIsOpenBol, setIsOpenBol } = useContext(AuthContext);
    const { setNumwats } = useContext(AuthContext);
    const { setQtdfun } = useContext(AuthContext);
    const { setFatcli } = useContext(AuthContext);
    const { setWhabol } = useContext(AuthContext);

    async function GetDados() {
        await api.get(`info?cgccli=${cgccli}`)
            .then((response) => {
                if (!response.data.msg) {
                    setEndCli(response.data.endcli);
                    setFoncla(response.data.foncla);
                    setEndele(response.data.endele);
                    setWhatsa(response.data.numwats);
                    setbol(response.data.whabol);
                    setWhabol(response.data.whabol);
                    setQtd(response.data.qtdfun);
                    setFat(response.data.fatcli);
                    setNumwats(response.data.numwats);
                    setQtdfun(response.data.qtdfun);
                    setFatcli(response.data.fatcli);
                    setImgcli(response.data.imgcli);
                    setSencli(response.data.sencli);

                } else {
                    Alerta('Erro', response.data.msg, 'error');
                }
            }).catch((erro) => {
                Alerta('Erro', erro, 'error');
            })
    }

    async function SaveSen() {
        await api.put(`info/senha?cgccli=${cgccli}&sencli=${sencli}`)
            .then((response) => {
                if (!response.data.msg) {
                    Alerta('Sucesso', 'Senha Atualizada!', 'success');
                } else {
                    Alerta('Erro', response.data.msg, 'error');
                }
            }).catch((erro) => {
                Alerta('Erro', erro, 'error');
            })
    }


    function openModal() {
        setIsOpenE(true);
    }

    function openModalW() {
        setIsOpenW(true);
    }

    function openModalF() {
        setIsOpenF(true);
    }

    function openModalL() {
        setIsOpenL(true);
    }

    function openModalB() {
        setIsOpenBol(true);
    }


    function closeModal() {
        setIsOpenE(false);
    }

    function closeModalW() {
        setIsOpenW(false);
    }

    function closeModalF() {
        setIsOpenF(false);
    }

    function closeModalB() {
        setIsOpenBol(false);
    }

    function closeModalL() {
        setIsOpenL(false);
    }
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',

        },
    };

    useEffect(() => {
        GetDados();

    }, [])



    return (
        <div className={styled.page}>
            <Menu menu='dados' />
            <div className={styled.container}>
                <Header page='Dados da Empresa' />
                <div className={styled.card}>
                    <div className={styled.cardheader}>
                        <div className={styled.cardtitle}>
                            <a>Dados da Empresa</a>
                            <div className={styled.cardtitleline}></div>
                        </div>
                    </div>
                    <div className={styled.cardcontent}>
                        <div className={styled.appdados}>
                            <div className={styled.frame1}>
                                <div className={styled.divcnpj}>
                                    <a>CNPJ</a>
                                    <span>{cgccli}</span>
                                </div>
                                <div className={styled.divcnpj}>
                                    <a>NOME DA EMPRESA</a>
                                    <span>{nomcli}</span>
                                </div>
                                <div className={styled.divcnpj}>
                                    <a>TELEFONE</a>
                                    <div className={styled.alteratel}>
                                        <span>{foncla}</span>
                                        {/*<CiEdit className={styled.iconedit} />*/}
                                    </div>
                                </div>
                                <div className={styled.divcnpj}>
                                    <a>WHATSAPP</a>
                                    <div className={styled.alteratel}>
                                        <span>{whatsa}</span>
                                        <CiEdit className={styled.iconedit} onClick={() => openModalW()} />
                                    </div>
                                    <ModalW isOpen={modalIsOpenW} onRequestClose={closeModalW} style={customStyles}>
                                        <ModalWats />
                                    </ModalW>
                                </div>
                                <div className={styled.divcnpj1}>
                                    <p>RECEBIMENTO DE BOLETOS</p>
                                    <div className={styled.alteratel1}>
                                        <span>{whabol}</span>
                                        
                                        <div className={styled.iconw}>
                                            <BsWhatsapp onClick={() => openModalB()} className={styled.iconwats} />
                                        </div>

                                    </div>



                                    <ModalB isOpen={modalIsOpenBol} onRequestClose={closeModalB} style={customStyles}>
                                        <ModalWhabol />
                                    </ModalB>
                                </div>
                                <div className={styled.divendereco}>
                                    <a>ENDEREÇO</a>
                                    <span>{endcli}</span>
                                </div>
                                <div className={styled.divcnpj}>
                                    <a>ALTERAR SENHA</a>
                                    <div className={styled.alteratel}>
                                        <input type='password' value={sencli} onChange={(e) => setSencli(e.target.value)}></input>
                                        <BiCheck className={styled.iconsave} onClick={() => SaveSen()} />
                                    </div>

                                </div>
                                <div className={styled.divcnpj}>
                                    <a>EMAIL ACESSO ÀREA DO CLIENTE</a>
                                    <span>{endele}</span>
                                    <a>* Para alterar este endereço entre em contato com a Cozimax</a>
                                </div>
                                <div className={styled.btnemails} onClick={() => openModal()}>
                                    OUTROS E-MAILS
                                </div>
                                <Modal isOpen={modalIsOpenE} onRequestClose={closeModal} style={customStyles}>
                                    <ModalEmail />
                                </Modal>
                            </div>
                            <div className={styled.frame2}>
                                <div className={styled.frame2header}>
                                    <div className={styled.frame2headerdesc}>
                                        <a>Logotipo</a>
                                    </div>
                                    <div className={styled.divlogo}>
                                        {imgcli ?
                                            <img src={imgcli} alt="" className={styled.logo}></img> :
                                            null
                                        }
                                        <CiEdit className={styled.iconedit2} onClick={() => openModalL()} />
                                    </div>
                                    <ModalL isOpen={modalIsOpenL} onRequestClose={closeModalL} style={customStyles}>
                                        <ModalLogo />

                                    </ModalL>
                                </div>
                                <div className={styled.frame2dados}>
                                    <a>Ajude-nos a personalizar nosso atendimento</a>
                                    <div className={styled.divalt}>
                                        <a>QUANTIDADE DE FUNCIONÁRIOS</a>
                                        <div className={styled.divaltqtd}>
                                            <span>{qtdfun}</span>
                                            <CiEdit className={styled.iconedit2} onClick={() => openModalF()} />
                                        </div>
                                    </div>
                                    <div className={styled.divalt}>
                                        <a>FATURAMENTO ANUAL</a>
                                        <div className={styled.divaltqtd}>
                                            <span>{fatcli}</span>
                                            <CiEdit className={styled.iconedit2} onClick={() => openModalF()} />
                                        </div>
                                    </div>
                                    <ModalW isOpen={modalIsOpenF} onRequestClose={closeModalF} style={customStyles}>
                                        <ModalFatu />

                                    </ModalW>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}


export default Empresa;